import React from 'react'
import {
  BriefcaseIcon,
  CalendarIcon,
  CarIcon,
  CoinStack,
  DocumentIcon,
  EmailIcon,
  MedalIcon,
  StatementsIcon,
  TickIcon,
} from '../../components/SVGIcons'

const flexibleIconList = [
  {
    icon: <MedalIcon />,
    description: 'fleet-icon-list medal',
  },
  {
    icon: <CoinStack width={32} height={32} />,
    description: 'fleet-icon-list coin-stack',
  },
  {
    icon: <TickIcon />,
    description: 'fleet-icon-list tick',
  },
  {
    icon: <CalendarIcon />,
    description: 'fleet-icon-list calendar',
  },
  {
    icon: <BriefcaseIcon />,
    description: 'fleet-icon-list briefcase',
  },
]

const requiredDocumentsIconList = [
  {
    icon: <DocumentIcon />,
    description: 'fleet-icon-list required document',
  },
  {
    icon: <StatementsIcon />,
    description: 'fleet-icon-list required statements',
  },
]

export const productFeaturesData = {
  fleet: [
    {
      type: 'FORTY',
      subType: 'cta',
      title: 'fleet-FORTY-1-title',
      imageUrl: null,
      subtitle: null,
      fancyTitle: null,
      ctaType: 'button',
      icon: <EmailIcon />,
      ctaTitle: 'fleet-FORTY-1-cta',
      ctaHref: '/contact-us',
      richText: null,
      left: true,
    },
    {
      type: 'SIXTY',
      subType: 'svg',
      title: 'fleet-SIXTY-1-title',
      subtitle: null,
      imageShouldSwitchLocale: true,
      imageUrl: null,
      fancyTitle: null,
      ctaTitle: null,
      ctaHref: null,
      icon: <CarIcon />,
      richText: null,
    },
    {
      type: 'SEVENTY',
      subType: 'svg',
      title: 'fleet-SEVENTY-1-title',
      subtitle: null,
      imageUrl: null,
      fancyTitle: null,
      ctaTitle: null,
      ctaHref: null,
      icon: null,
      iconList: flexibleIconList,
      richText: null,
    },
    {
      type: 'THIRTY',
      subType: 'svg',
      title: 'fleet-THIRTY-1-title',
      footerText: 'fleet-THIRTY-1-footer-text',
      imageUrl: null,
      fancyTitle: null,
      ctaTitle: null,
      ctaHref: null,
      icon: <CarIcon />,
      iconList: requiredDocumentsIconList,
      richText: null,
    },
  ],
}
